/**
 * TRACKERS GTM
 * 
 * module de gestion des trackers GTM
 */
import $ from "jquery";
const utils = require('./utils.js').default;
import { strings } from "../../../helpers/strings.js";
import { gtm } from '../../../components/gtm.js';

const trackers = (() => {
    const TRACKERS_ENABLED = true;
    /**
     * TRACKER ADDRESS CREATE
     */
    const trackerAddressCreate = () => {
        document.addEventListener('TRACKERS_ADDRESS_CREATE', (event) => {
            utils.debug('TRACKER ADDRESS CREATE', event.detail.name);
            gtm.track({
                'event': 'CreateAddress',
                'eventCategory': 'address',
                'eventAction': 'popin-address-create',
                'eventLabel': event.detail.name,
            });
        });
    };
    /**
     * TRACKER ADDRESS DELETE
     */
    const trackerAddressDelete = () => {
        document.addEventListener('TRACKERS_ADDRESS_DELETE', (event) => {
            utils.debug('TRACKER ADDRESS DELETE', event.detail.name);
            gtm.track({
                'event': 'DeleteAddress',
                'eventCategory': 'address',
                'eventAction': 'popin-address-delete',
                'eventLabel': event.detail.name,
            });
        });
    };
    /**
     * TRACKER ADDRESS UPDATE
     */
    const trackerAddressUpdate = () => {
        document.addEventListener('TRACKERS_ADDRESS_UPDATE', (event) => {
            utils.debug('TRACKER ADDRESS UPDATE', event.detail.name);
            gtm.track({
                'event': 'UpdateAddress',
                'eventCategory': 'address',
                'eventAction': 'popin-address-update',
                'eventLabel': event.detail.name,
            });
        });
    };
    /**
     * TRACKER CREATE WISHLIST
     */
    const trackerCreateWishlist = () => {
        document.addEventListener('TRACKERS_CREATE_WISHLIST', (event) => {
            utils.debug('TRACKER CREATE WISHLIST', event.detail.name);
            gtm.track({
                'event': 'createWishlist',
                'eventCategory': 'wishlist',
                'eventAction': 'create_list',
                'eventLabel': event.detail.name
            });
        });
    };
    /**
     * TRACKER DOCUMENTS ADD
     */
    const trackerDocumentAdd = () => {
        document.addEventListener('TRACKERS_DOCUMENTS_ADD', (event) => {
            utils.debug('TRACKER DOCUMENTS ADD', event.detail.name);
            gtm.track({
                'event': 'add_doc_to_fav',
                'eventCategory': 'Documents favoris',
                'eventAction': document.title,
                'eventLabel': event.detail.type,
                'eventValue': event.detail.name,
            });
        });
    };
    /**
     * TRACKER DOCUMENTS DELETE
     */
    const trackerDocumentDelete = () => {
        document.addEventListener('TRACKERS_DOCUMENTS_DELETE', (event) => {
            utils.debug('TRACKER DOCUMENTS DELETE', event.detail.name);
            gtm.track({
                'event': 'delete_doc_to_fav',
                'eventCategory': 'Documents favoris',
                'eventAction': document.title,
                'eventLabel': event.detail.type,
                'eventValue': event.detail.name,
            });
        });
    };
    /**
     * TRACKER DOWNLOAD TECHNICAL DOCUMENTS
     */
    const trackerDownloadTechnicalDocuments = () => {
        document.addEventListener('TRACKERS_DOWNLOAD_TECHNICAL_DOCUMENTS', (event) => {
            utils.debug('TRACKER DOWNLOAD TECHNICAL DOCUMENTS', event.detail.options.join(','));
            gtm.track({
                'event': 'wishlistTechDoc',
                'eventCategory': 'wishlist',
                'eventAction': 'popup_download_technical_documents',
                'eventLabel': event.detail.options.join(','),
            });
        });
    };
    /**
     * TRACKER LOAD SHARE WISHLIST
     */
    const trackerLoadShareWishlist = () => {
        document.addEventListener('TTRACKER_LOAD_SHARE_WISHLIST', (event) => {
            utils.debug('TRACKER LOAD SHARE WISHLIST', event.detail.name);
            gtm.track({
                'event': 'LoadShareWishlist',
                'eventCategory': 'wishlist',
                'eventAction': 'popin-import-share-list-success',
                'eventLabel': event.detail.name,
            });
        });
    };
    /**
     * TRACKER PRINT WISHLIST
     */
    const trackerPrintWishlist = () => {
        document.addEventListener('TRACKERS_PRINT_WISHLIST', (event) => {
            utils.debug('TRACKER DOWNLOAD TECHNICAL DOCUMENTS', event.detail);
            gtm.track({
                'event': 'wishlistIcon',
                'eventCategory': 'wishlist',
                'eventAction': 'popup_print_wishlit',
                'eventLabel': event.detail.options,
                'eventValue': `${event.detail.productsCount}:${event.detail.grandTotal}`
            });
        });
    };
    /**
     * TRACKER TRANSACTION SUCCESS
     */
    const trackerTransactionSuccess = () => {
        document.addEventListener('TRACKERS_TRANSACTION_SUCCESS', (event) => {
            utils.debug('TRACKER TRANSACTION SUCCESS', event.detail);
            gtm.track({
                'event': 'transaction-success',
                'ecommerce': {
                    'purchase': {
                        'actionField': {
                            'id': +new Date(),
                            'affiliation': '',
                            'revenue': event.detail.revenue,
                            'tax': '',
                            'shipping': '',
                            'coupon': event.detail.coupon,
                            'list_label': event.detail.list_label,
                            'list_category': event.detail.list_category,
                            'print_features': event.detail.print_features,
                        },
                        'products': event.detail.products,
                    }
                }
            });
        });
    };
    /**
     * TRACKER WISHLIST CHECKOUT
     */
    const trackerWishlistCheckout = () => {
        document.addEventListener('TRACKERS_WISHLIST_CHECKOUT', (event) => {
            utils.debug('TRACKER WISHLIST CHECKOUT', event.detail);
            gtm.track({
                'event': 'checkoutWishlist',
                'ecommerce': {
                    'checkout': {
                        'actionField': {
                            'step': 1,
                            'list_label': event.detail.listLabel,
                            'list_category': event.detail.listCategory
                        },
                        'products': event.detail.products
                    }
                }
            });
        });
    };
    /**
     * TRACKER WISHLIST CHECKOUT OUVERTURE POPIN
     */
    const trackerWishlistCheckoutOpenPopin = () => {
        document.addEventListener('TRACKERS_WISHLIST_CHECKOUT_OPEN_POPIN', (event) => {
            utils.debug('TRACKER WISHLIST CHECKOUT OPEN POPIN', event.detail);
            gtm.track({
                'event': 'checkoutOuverturePopin',
                'ecommerce': {
                    'checkout': {
                        'actionField': {
                            'step': 2,
                            'list_label': event.detail.listLabel,
                            'list_category': event.detail.listCategory
                        },
                        'products': event.detail.products
                    }
                }
            });
        });
    };
    /**
     * TRACKER WISHLIST DELETE LIST
     */
    const trackerWishlistDeleteList = () => {
        document.addEventListener('TRACKERS_WISHLIST_DELETE_LIST', (event) => {
            utils.debug('TRACKER WISHLIST DELETE LIST', event.detail.name);
            gtm.track({
                'event': 'wishlistIcon',
                'eventCategory': 'wishlist',
                'eventAction': 'popup_delete_wishlist',
                'eventLabel': event.detail.name,
            });
        });
    };
    /**
     * TRACKER WISHLIST DUPLICATE LIST
     */
    const trackerWishlistDuplicateList = () => {
        document.addEventListener('TRACKERS_WISHLIST_DUPLICATE_LIST', (event) => {
            utils.debug('TRACKER WISHLIST DELETE LIST', event.detail);
            gtm.track({
                'event': 'wishlistIcon',
                'eventCategory': 'wishlist',
                'eventAction': 'popup_duplicate_wishlist',
                'eventLabel': `new:${event.detail.listNewId}`,
                'eventValue': `old:${event.detail.listDuplicateId}`,
            });
        });
    };
    /**
     * TRACKER WISHLIST EXPORT
     */
    const trackerWishlistExport = () => {
        document.addEventListener('TRACKERS_WISHLIST_EXPORT', (event) => {
            utils.debug('TRACKER WISHLIST EXPORT', event.detail);
            gtm.track({
                'event': 'wishlistDownload',
                'eventCategory': 'wishlist',
                'eventAction': 'download_wishlist',
                'eventLabel': strings.snakeCase(event.detail.format),
                'eventValue': `${event.detail.quantity}:${event.detail.total}`,
            });
        });
    };
    /**
     * TRACKER WISHLIST IMPORT
     */
    const trackerWishlistImport = () => {
        document.addEventListener('TRACKERS_WISHLIST_IMPORT', (event) => {
            utils.debug('TRACKER WISHLIST IMPORT', event.detail);
            gtm.track({
                'event': 'wishlistIcon',
                'eventCategory': 'wishlist',
                'eventAction': 'import_wishlist',
                'eventLabel': event.detail.format.toUpperCase(),
                'eventValue': event.detail.type
            });
        });
    };
    /**
     * TRACKER WISHLIST LOAD
     */
    const trackerWishlistLoad = () => {
        document.addEventListener('TRACKERS_WISHLIST_LOAD', (event) => {
            utils.debug('TRACKER WISHLIST LOAD', event.detail);
            gtm.track({
                'event': 'wishlistValue',
                'eventCategory': 'wishlist',
                'eventAction': 'wishlist_value',
                'eventLabel': `${event.detail.name}:${event.detail.type}`,
                'eventValue': `${event.detail.productsCount}:${event.detail.grandTotal}`
            });
        });
    };
    /**
     * TRACKER WISHLIST PRODUCT ADD
     */
    const trackerWishlistProductAdd = () => {
        document.addEventListener('TRACKERS_WISHLIST_PRODUCT_ADD', (event) => {
            utils.debug('TRACKER WISHLIST PRODUCT ADD', event.detail);
            gtm.track({
                'event': event.detail.event,
                'eventCategory': event.detail.eventCategory,
                'eventAction': 'add_product_wishlist',
                'eventLabel': event.detail.eventLabel,
                'eventValue': event.detail.eventValue,
            });
        });
    }
    /**
     * TRACKER WISHLIST PRODUCTS ADD TO CART
     */
    const trackerWishlistProductsAddToCart = () => {
        document.addEventListener('TRACKER_WISHLIST_PRODUCTS_ADD_TO_CART', (event) => {
            utils.debug('TRACKER WISHLIST PRODUCTS ADD TO CART', event.detail);
            gtm.track({
                'event': 'addToCart',
                'list_label': event.detail.listLabel,
                'list_category': event.detail.listCategory,
                'ecommerce': {
                    'add': {
                        'products': event.detail.products
                        // [
                            // {
                            // 'name': '$product_label',
                            // 'id': '$REF. NV-2IC6-ANG',
                            // 'price': '$176.00',
                            // 'brand': 'Legrand',
                            // 'category': '$product_category',
                            // 'variant': '',
                            // 'quantity': $1
                            // }
                        // ]
                    }
                }
            });
        });
    }

    /**
     * TRACKER WISHLIST PRODUCTS REMOVE FROM CART
     */
    const trackerWishlistProductsRemoveFromCart = () => {
        document.addEventListener('TRACKER_WISHLIST_PRODUCTS_REMOVE_FROM_CART', (event) => {
            utils.debug('TRACKER WISHLIST PRODUCTS REMOVE FROM CART', event.detail);
            gtm.track({
                'event': 'removeFromCart',
                'list_label': event.detail.listLabel,
                'list_category': event.detail.listCategory,
                'ecommerce': {
                    'remove': {
                        'products': event.detail.products
                        // [
                            // {
                            // 'name': '$product_label',
                            // 'id': '$REF. NV-2IC6-ANG',
                            // 'price': '$176.00',
                            // 'brand': 'Legrand',
                            // 'category': '$product_category',
                            // 'variant': '',
                            // 'quantity': $1
                            // }
                        // ]
                    }
                }
            });
        });
    }
    /**
     * TRACKER WISHLIST PRODUCT DELETE
     */
    const trackerWishlistProductDelete = () => {
        document.addEventListener('TRACKERS_WISHLIST_PRODUCT_DELETE', (event) => {
            utils.debug('TRACKER WISHLIST PRODUCT DELETE', event.detail);
            gtm.track({
                'event': 'wishlistIcon',
                'eventCategory': 'wishlist',
                'eventAction': 'popup_delete_product_wishlist',
                'eventLabel': event.detail.productLabel,
                'eventValue': `${event.detail.productsCount}:${event.detail.grandTotal}`
            });
        });
    };
    /**
     * TRACKER WISHLIST PRODUCT MOVE
     */
    const trackerWishlistProductMove = () => {
        document.addEventListener('TRACKERS_WISHLIST_PRODUCT_MOVE', (event) => {
            utils.debug('TRACKER WISHLIST PRODUCT MOVE', event.detail);
            gtm.track({
                'event': 'wishlistMoveProduct',
                'eventCategory': 'wishlist',
                'eventAction': 'move_product_list',
                'eventLabel': event.detail.productCategory,
                'eventValue': event.detail.productLabel
            });
        });
    };
    /**
     * TRACKER WISHLIST PRODUCT QUANTITY CHANGE
     */
    const trackerWishlistProductQuantityChange = () => {
        document.addEventListener('TRACKERS_WISHLIST_PRODUCT_QUANTITY_CHANGE', (event) => {
            utils.debug('TRACKER WISHLIST PRODUCT QUANTITY CHANGE', event.detail);
            gtm.track({
                'event': 'wishlistProductQuantity',
                'eventCategory': 'wishlist',
                'eventAction': 'change_quantity',
                'eventLabel': event.detail.name,
                'eventValue': `${event.detail.quantity}:${event.detail.totalPrice}`,
            });
        });
    };
    /**
     * TRACKER WISHLIST RENAME LIST
     */
    const trackerWishlistRenameList = () => {
        document.addEventListener('TRACKERS_WISHLIST_RENAME_LIST', (event) => {
            utils.debug('TRACKER WISHLIST RENAME LIST', event.detail);
            gtm.track({
                'event': 'wishlistIcon',
                'eventCategory': 'wishlist',
                'eventAction': 'popup_rename_wishlist',
                'eventLabel': event.detail.listNewName,
                'eventValue': `${event.detail.quantity}:${event.detail.totalPrice}`,
            });
        });
    };
    /**
     * INIT (func)
     */
    const init = () => {
        if (TRACKERS_ENABLED) {
            trackerAddressCreate();
            trackerAddressDelete();
            trackerAddressUpdate();
            trackerCreateWishlist();
            trackerDocumentAdd();
            trackerDocumentDelete();
            trackerDownloadTechnicalDocuments();
            trackerLoadShareWishlist();
            trackerPrintWishlist();
            trackerTransactionSuccess();
            trackerWishlistCheckout();
            trackerWishlistCheckoutOpenPopin();
            trackerWishlistDeleteList();
            trackerWishlistDuplicateList();
            trackerWishlistExport();
            trackerWishlistImport();
            trackerWishlistLoad();
            trackerWishlistProductAdd();
            trackerWishlistProductsAddToCart();
            trackerWishlistProductsRemoveFromCart();
            trackerWishlistProductDelete();
            trackerWishlistProductMove();
            trackerWishlistProductQuantityChange();
            trackerWishlistRenameList();
        }
    }
    return {init};
})();
export default trackers;